import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Task from '../../entities/task';
import Invoice from '../../entities/invoice';
import Document from '../../entities/document';
import Comment from '../../entities/comment';
export function deleteTask(task: Task, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = task.id;}
const _work = workingSet();
store.getState().invoices.getMappingFor('taskId', task.id).filter(invoiceTemp => invoiceTemp.status !== 'D').forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.taskPositions = _invoice.taskPositions?.filter(id => id !== task.id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});



task.status = 'D';
task.addedOn = newHRTimestamp();
task.addedBy = getCurrentUserId();
task.importSource = targetImportSource;
task.importId = mergeId;
store.dispatch(Actions.TaskActions.removeTaskQueue(task));
findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'task' && documentTemp.entityId === task.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.status = 'D';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.removeDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'task' && commentTemp.entityId === task.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.status = 'D';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.removeCommentQueue(_comment));
});
}
export function replaceTask(task: Task, replaceWith: Task, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = task.id;}
const _work = workingSet();
store.getState().invoices.getMappingFor('taskId', task.id).filter(invoiceTemp => invoiceTemp.status !== 'D').forEach(invoiceTemp => {
const _invoice = ((_work.get('invoice:' + invoiceTemp.id) ?? invoiceTemp) as Invoice).clone();
_invoice.status = 'U';
_invoice.addedOn = newHRTimestamp();
_invoice.addedBy = getCurrentUserId();
_invoice.importSource = targetImportSource;
_invoice.importId = mergeId;
_invoice.taskPositions = _invoice.taskPositions?.map(id => (id === task.id) ? replaceWith.id : id) || [];

_work.set('invoice:' + _invoice.id, _invoice);
store.dispatch(Actions.InvoiceActions.saveInvoiceQueue(_invoice));
});



findAll<Document>('documents').filter(documentTemp => documentTemp.entityType === 'task' && documentTemp.entityId === task.id && documentTemp.status !== 'D').forEach(documentTemp => {
const _document = ((_work.get('document:' + documentTemp.id) ?? documentTemp) as Document).clone();
_document.entityId = replaceWith.id;
_document.status = 'U';
_document.addedOn = newHRTimestamp();
_document.addedBy = getCurrentUserId();
_document.importSource = targetImportSource;
_document.importId = mergeId;
_work.set('document:' + _document.id, _document);
store.dispatch(Actions.DocumentActions.saveDocumentQueue(_document));
});
findAll<Comment>('comments').filter(commentTemp => commentTemp.entityType === 'task' && commentTemp.entityId === task.id && commentTemp.status !== 'D').forEach(commentTemp => {
const _comment = ((_work.get('comment:' + commentTemp.id) ?? commentTemp) as Comment).clone();
_comment.entityId = replaceWith.id;
_comment.status = 'U';
_comment.addedOn = newHRTimestamp();
_comment.addedBy = getCurrentUserId();
_comment.importSource = targetImportSource;
_comment.importId = mergeId;
_work.set('comment:' + _comment.id, _comment);
store.dispatch(Actions.CommentActions.saveCommentQueue(_comment));
});
return task;
}
export function deleteImpactTask(task: Task) {
const impacts: string[] = [];
const state = store.getState();
const invoiceTaskIdsImpact = state.invoices.getMappingFor('taskIds', task.id).filter(invoice => invoice.status !== 'D');
invoiceTaskIdsImpact.forEach(() => impacts.push('invoices'));
const invoiceTaskPositionsImpact = state.invoices.getMappingFor('taskId', task.id).filter(invoice => invoice.status !== 'D');
invoiceTaskPositionsImpact.forEach(() => impacts.push('invoices'));



return util.countDistinct(impacts);
}
